import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

export interface MasonryItem {
  imageUrl: string;
  imageAlt?: string;
  title?: string;
  textColor?: 'LIGHT' | 'DARK';
}

export interface Props {
  editor?: object;
  items: MasonryItem[];
  colorTheme?: 'LIGHT' | 'DARK';
}

const propsSchema: PropsSchemaList = [
  {
    key: 'items',
    label: 'Masonry Items',
    type: types.ARRAY,
    children: [
      {
        key: 'imageUrl',
        label: 'Image URL',
        type: types.S3_ASSET_URL,
      },
      {
        key: 'imageAlt',
        label: 'Image Alt Text',
        tooltip: 'This is important for SEO and accessibility. This is not shown on the page.',
        type: types.TEXT,
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT,
      },
      {
        key: 'textColor',
        label: 'Text Color',
        type: types.ENUM,
        options: ['LIGHT', 'DARK'],
      },
    ],
  },
  {
    key: 'colorTheme',
    label: 'Color Theme',
    type: types.ENUM,
    options: ['LIGHT', 'DARK'],
  },
];

const defaultProps: Props = {
  items: [
    {
      imageUrl: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-01.jpg',
      imageAlt: '',
      title: 'One',
      textColor: 'LIGHT',
    },
    {
      imageUrl: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-02.jpg',
      imageAlt: '',
      title: 'Two',
      textColor: 'LIGHT',
    },
    {
      imageUrl: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-03.jpg',
      imageAlt: '',
      title: 'Three',
      textColor: 'LIGHT',
    },
    {
      imageUrl: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-04.jpg',
      imageAlt: '',
      title: 'Four',
      textColor: 'LIGHT',
    },
    {
      imageUrl: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-05.jpg',
      imageAlt: '',
      title: 'Five',
      textColor: 'LIGHT',
    },
    {
      imageUrl: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-06.jpg',
      imageAlt: '',
      title: 'Six',
      textColor: 'LIGHT',
    },
    {
      imageUrl: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-01.jpg',
      imageAlt: '',
      title: 'Seven',
      textColor: 'LIGHT',
    },
    {
      imageUrl: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-02.jpg',
      imageAlt: '',
      title: 'Eight',
      textColor: 'LIGHT',
    },
  ],
  colorTheme: 'LIGHT',
};

export default {
  title: 'Masonry',
  id: 'Masonry',
  propsSchema,
  defaultProps,
}
